// extracted by mini-css-extract-plugin
export var interacMethodIcon = "InteracMethodIcon-module--interacMethodIcon--185cd";